import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import { LocaleContext } from 'Components/hooks/context';
import SmartText from '@reuters-graphics/react-smart-text';

const atlas = new AtlasMetadataClient();

const Headline = ({ smartText }) => {
  const { context, source } = smartText;
  const country = atlas.getCountry(context.country);
  const locale = useContext(LocaleContext);
  return (
    <h3>
      <SmartText
        source={source}
        context={{
          ...context,
          country: country.translations[locale],
        }}
      />
    </h3>
  );
};

export default Headline;
